import { isSet } from '@utils';
import { GroupedDomainsDescriptions } from '@models/feature-space';
import { DomainsDescription } from '@models/feature-descriptor-domain';

export interface DescriptionsTree {
  types: DescriptionsTypeTree[];
}

export interface DescriptionsTypeTree {
  nodeId: DescriptionsTree.NodeId;
  summary: string;
  columns: DescriptionsColumnTree[];
}

export interface DescriptionsColumnTree {
  nodeId: DescriptionsTree.NodeId;
  summary: string;
  descriptions: Array<DomainsDescription & { nodeId: DescriptionsTree.NodeId }>;
}

export namespace DescriptionsTree {
  export type NodeId = string;

  export function appendNodeId(
    groups: GroupedDomainsDescriptions,
    prefix?: string
  ): DescriptionsTree {
    const id = DescriptionsTree.createGroupId(prefix);

    return {
      types: groups.types.map((type, typeIdx) => {
        return {
          nodeId: id({ typeIdx }),
          summary: type.summary,
          columns: type.columns.map((column, columnIdx) => ({
            nodeId: id({ typeIdx, columnIdx }),
            summary: column.summary,
            descriptions: column.descriptions.map(
              (description, descriptionIdx) => ({
                ...description,
                nodeId: id({ typeIdx, columnIdx, descriptionIdx }),
              })
            ),
          })),
        };
      }),
    };
  }

  export function createGroupId(prefix?: string) {
    return (props: {
      typeIdx?: string | number;
      columnIdx?: string | number;
      descriptionIdx?: string | number;
    }): NodeId => {
      return [
        isSet(prefix) && `${prefix}`,
        isSet(props.typeIdx) && `t${props.typeIdx}`,
        isSet(props.columnIdx) && `c${props.columnIdx}`,
        isSet(props.descriptionIdx) && `d${props.descriptionIdx}`,
      ]
        .filter(Boolean)
        .join('_');
    };
  }
}
